import { createContext, useContext, type ReactNode } from 'react';

interface IMonitorUpsellModalContext {
  openMonitoringUpsellConfirmModal: () => void;
}

const MonitorUpsellModalContext =
  createContext<IMonitorUpsellModalContext | null>(null);

/**
 * Provides access to the monitoring addon confirm modal (OAR-2073) for surfaces that cannot
 * receive props from the route (e.g. Recent Reports list).
 */
export function MonitorUpsellModalProvider({
  children,
  openMonitoringUpsellConfirmModal,
}: {
  children: ReactNode;
  openMonitoringUpsellConfirmModal: () => void;
}): JSX.Element {
  return (
    <MonitorUpsellModalContext.Provider
      value={{ openMonitoringUpsellConfirmModal }}
    >
      {children}
    </MonitorUpsellModalContext.Provider>
  );
}

export function useMonitorUpsellModalContext(): IMonitorUpsellModalContext | null {
  return useContext(MonitorUpsellModalContext);
}
